import { inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { catchError, map, Observable, of } from 'rxjs';

import { AuthBootstrapService } from '../services/auth-bootstrap.service';

export const loggedInGuard: CanActivateFn = (): boolean | UrlTree | Observable<boolean | UrlTree> => {
  const router = inject(Router);
  const authBootstrap = inject(AuthBootstrapService);

  return authBootstrap.ensureSessionReady().pipe(
    map((session): boolean | UrlTree => {
      if (authBootstrap.isGuest(session)) {
        return true;
      }
      if (!authBootstrap.canAccessProtectedRoutes(session)) {
        return true;
      }
      return router.createUrlTree(['/']);
    }),
    catchError((): Observable<boolean> => of(true)),
  );
};
